import React from "react";
import styled from "styled-components";

const ListMenu = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  width: 298px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
`;

const ListMenuItem = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  cursor: pointer;
`;

const MenuItemContent = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  align-self: stretch;
  background: ${(props) => (props.active ? "rgb(97, 98, 197)" : "transparent")};
  box-sizing: border-box;
  padding: 12px 16px;
  flex-shrink: 0;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${(props) =>
      props.active ? "rgb(97, 98, 197)" : "rgba(97, 98, 197, 0.1)"};
  }
`;

const MenuItemText = styled.span`
  color: ${(props) => (props.active ? "white" : "rgb(33, 37, 67)")};
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
`;

const SidebarNav = ({ activeItem, onItemClick }) => {
  const menuItems = [
    { id: "general", label: "General" },
    { id: "edit-picture", label: "Edit Picture" },
    { id: "password", label: "Password" },
    { id: "bank-details", label: "Bank Details" },
    { id: "delete-account", label: "Delete Account" },
  ];

  return (
    <ListMenu>
      {menuItems.map((item) => (
        <ListMenuItem key={item.id} onClick={() => onItemClick(item.id)}>
          <MenuItemContent active={activeItem === item.id}>
            <MenuItemText active={activeItem === item.id}>
              {item.label}
            </MenuItemText>
          </MenuItemContent>
        </ListMenuItem>
      ))}
    </ListMenu>
  );
};

export default SidebarNav;
